import config from 'devextreme/core/config';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { initializeAuth } from '@/core/auth/msal';
import { licenseKey } from '@/devextreme-license';

import '@/styles/main.scss';

config({ licenseKey });

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

// A login redirect may be landing on this page load; RequireAuth must see
// the account it produced before the first render.
void initializeAuth()
  .catch((err: unknown) => console.warn('auth initialisation failed', err))
  .then(() => {
    createRoot(container).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
